import React from 'react'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import Contact from '../organims/Contact'

const ContactUs=(props)=>{
  const socialn=[1,2,3,4,5,6]
  useEffect(()=>{
    document.documentElement.scrollTop=0
  },[])

  return <>
  <div className="my-networks">
    <h1>Mis redes sociales</h1>
    <div className="networks-container">
      {
        props.data
        ?props.data.networks.map(n=>(
          
            <div key={n.name} className="network-item">
              <a href={n.url} target="_blank" rel="noopener noreferrer" className='network-link'>
                <div className="network-image-container">
                  <img src={n.image} alt={n.name} className="network-image"/>
                </div>
                <p>{n.text}</p>
              </a>
            </div>
          
        ))
        :
        socialn.map(s=>(
          <div key={s} className="network-item">
            <a href='luisdevs.vercel.app' className='network-link'>
              <div className="network-image-container ske pagecontact">
                <p className="network-image"/>
              </div>
              <p className='ske pagecontact'></p>
            </a>
          </div>
        ))
      }
    </div>
  </div>
  <Contact phrase='Mi mayor pasatiempo, seguir aprendiendo...' />
  </>
}

const mapStateToProps=(state)=>(
  {data:state.data}
)

export default connect(mapStateToProps,{})(ContactUs)
